(() => {
  'use strict';

  const MOBILE_BREAKPOINT = 1200;

  function initialiseZyviraMobileMenu(drawer) {
    if (!drawer || drawer.dataset.zyvInitialised === 'true') return;

    drawer.dataset.zyvInitialised = 'true';

    const openButton = document.querySelector('.header1 button.navbar-toggle');
    const closeButton = drawer.querySelector('.zyv-mm__close');
    const overlay = document.querySelector('.mm-fullscreen-bg');
    const topLevelItems = Array.from(drawer.querySelectorAll('[data-zyv-menu-item]'));
    let wasOpen = drawer.classList.contains('active');

    function setAccessibilityState(isOpen) {
      drawer.setAttribute('aria-hidden', String(!isOpen));
      drawer.inert = !isOpen;

      if (openButton) {
        openButton.setAttribute('aria-controls', drawer.id);
        openButton.setAttribute('aria-expanded', String(isOpen));
      }

      document.body.classList.toggle('zyv-mm-open', isOpen);
      document.documentElement.classList.toggle('zyv-mm-open-html', isOpen);

      if (!isOpen) {
        document.body.classList.remove('ov-hidden');
      }
    }

    function openDrawer() {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;

      drawer.classList.add('active');
      overlay?.classList.add('active');
      document.body.classList.add('ov-hidden');
      setAccessibilityState(true);

      window.requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
    }

    function closeDrawer({ restoreFocus = true } = {}) {
      drawer.classList.remove('active');
      overlay?.classList.remove('active');
      document.body.classList.remove('ov-hidden', 'hidden');
      setAccessibilityState(false);

      if (restoreFocus) {
        openButton?.focus({ preventScroll: true });
      }
    }

    function closeSiblingTopItems(activeItem) {
      topLevelItems.forEach((item) => {
        if (item === activeItem) return;
        item.classList.remove('is-open');
        item.querySelector(':scope > [data-zyv-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }

    drawer.querySelectorAll('[data-zyv-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-zyv-menu-item]');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');
        closeSiblingTopItems(item);
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });

    drawer.querySelectorAll('[data-zyv-submenu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-zyv-submenu-item]');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');
        const parentGroup = item.parentElement;

        parentGroup?.querySelectorAll(':scope > [data-zyv-submenu-item]').forEach((sibling) => {
          if (sibling === item) return;
          sibling.classList.remove('is-open');
          sibling.querySelector(':scope > * > [data-zyv-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });

    openButton?.addEventListener('click', () => {
      window.requestAnimationFrame(openDrawer);
    });

    closeButton?.addEventListener('click', () => {
      closeDrawer();
    });

    overlay?.addEventListener('click', () => {
      if (drawer.classList.contains('active')) closeDrawer();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('active')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= MOBILE_BREAKPOINT && drawer.classList.contains('active')) {
        closeDrawer({ restoreFocus: false });
      }
    });

    const observer = new MutationObserver(() => {
      const isOpen = drawer.classList.contains('active');
      if (isOpen === wasOpen) return;

      wasOpen = isOpen;
      setAccessibilityState(isOpen);
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    setAccessibilityState(wasOpen);
  }

  function bootZyviraMobileMenu(root = document) {
    const drawer = root.querySelector?.('#ZyviraMobileMenu') || document.querySelector('#ZyviraMobileMenu');
    initialiseZyviraMobileMenu(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootZyviraMobileMenu());
  } else {
    bootZyviraMobileMenu();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bootZyviraMobileMenu(event.target);
  });
})();
